import React, { useEffect } from 'react'

import { ChatSectionTitle } from '../../components/ChatSectionTitle'
import { ChatSection } from '../../components/ChatSection'
import { useTitle } from '../../hooks/useTitle'
import { useAppState } from '../../Store'
import { Brand } from '../../api/types'

interface Props {
  brandType: Brand
}

// NB. This text is also used in the AdminClosed component
export const openingAgainTime = 'kl. 20:30 í kvöld.'

const ClosedComponent: React.FC<Props> = ({ brandType }: Props) => {
  return (
    <ChatSection>
      <ChatSectionTitle
        text={`Vegna uppfærslu hjá samstarfsaðila er tímabundið ekki hægt að kaupa ${brandType} tryggingu á vefnum. Við opnum aftur eftir ${openingAgainTime}.`}
      />
    </ChatSection>
  )
}

export const Closed = () => {
  const { setTitle } = useTitle()
  const { state } = useAppState()

  useEffect(() => {
    setTitle('Upphaf')
  }, [setTitle])

  return ClosedComponent({ brandType: state.brandType })
}
